import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { orientationList } from "../structureFunction";
import {
  handleInputChange,
  handleUpdateOrientation,
  handleWalkWayType,
} from "../DSFunction";

export default function CustomizeOption({ handleKeyPress }) {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const designParameter = useSelector((state) => state.designParameter);

  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];
  const [showOrientation, setShowOrientation] = useState(false);

  const handleOrientation = async (item) => {
    handleUpdateOrientation(
      item,
      setShowOrientation,
      dispatch,
      roofIndex,
      roofInfo,
      gridInfo,
      quantityInfo,
      roofDetail,
      designParameter
    );
  };

  return (
    <>
      <h1>Customize Option</h1>

      <div className="formWithLabel">
        <label>Panel Orientation</label>
        <div
          className="selectOption"
          onMouseLeave={() => setShowOrientation(false)}
        >
          <ul
            id="first"
            style={
              roofDetail.orientation === "Select"
                ? { border: "2px solid red" }
                : {}
            }
          >
            <li onClick={() => setShowOrientation(!showOrientation)}>
              {roofDetail.orientation === "Select" || !roofDetail.orientation
                ? "Select"
                : roofDetail.orientation}
              <i className="bi bi-chevron-down"></i>
            </li>
            {showOrientation && (
              <div
                className="dropDown"
                onMouseLeave={() => setShowOrientation(false)}
              >
                {orientationList.map((item, index) => (
                  <li
                    onClick={() => handleOrientation(item)}
                    key={index}
                    style={
                      roofDetail.orientation === item.orientation
                        ? { backgroundColor: "blue", color: "white" }
                        : {}
                    }
                  >
                    {item.orientation}
                  </li>
                ))}
              </div>
            )}
          </ul>
        </div>
      </div>
      {roofDetail.roofType === "Shed Roof" ? (
        <div className="formWithLabel shedForm">
          <div className="formShedInfo">
            <label>No of Row</label>
            <input
              type="text"
              placeholder="noOfRow"
              name="blockRow"
              value={roofDetail.blockRow}
              onChange={(e) => {
                handleInputChange(e, dispatch, roofIndex);
              }}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
          <div className="formShedInfo">
            <label>No Of Column</label>
            <input
              type="text"
              placeholder="noOfColumn"
              name="blockCol"
              value={roofDetail.blockCol}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
          <div className="formShedInfo">
            <label>Module Space(mm)</label>
            <input
              type="text"
              placeholder="Module Spacing"
              name="moduleSpacing"
              value={roofDetail.moduleSpacing}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
          <div className="formShedInfo">
            <label>Block Space(mm)</label>
            <input
              type="text"
              placeholder="Block Spacing"
              name="frameSpacing"
              value={roofDetail.frameSpacing}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
        </div>
      ) : (
        <div className="formWithLabel shedForm">
          <div className="formShedInfo">
            <label>Row Frame</label>
            <input
              type="text"
              placeholder="Row Frame"
              name="blockRow"
              value={roofDetail.blockRow}
              onChange={(e) => {
                handleInputChange(e, dispatch, roofIndex);
              }}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
          <div className="formShedInfo">
            <label>Col Frame</label>
            <input
              type="text"
              placeholder="Column Frame"
              name="blockCol"
              value={roofDetail.blockCol}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
          <div className="formShedInfo">
            <label>Module Space(mm)</label>
            <input
              type="text"
              placeholder="Module Spacing"
              name="moduleSpacing"
              value={roofDetail.moduleSpacing}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
          <div className="formShedInfo">
            <label>Frame Space(mm)</label>
            <input
              type="text"
              placeholder="Frame Spacing"
              name="frameSpacing"
              value={roofDetail.frameSpacing}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
          <div className="formShedInfo">
            <label>Tilt Angle(°)</label>
            <input
              type="text"
              placeholder="tiltAngle"
              name="tiltAngle"
              value={roofDetail.tiltAngle}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
          <div className="formShedInfo">
            <label>Front Height(mm)</label>
            <input
              type="text"
              placeholder="Front Height"
              name="frontHeight"
              value={roofDetail.frontHeight}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
          <div className="formWithLabel">
            <div
              className="walkWayParameter"
              style={{
                marginBottom: "0px",
                marginTop: "8px",
              }}
            >
              <span
                onClick={() =>
                  handleWalkWayType("With", dispatch, roofIndex, roofDetail)
                }
                style={
                  roofDetail.walkWayType === "With"
                    ? { backgroundColor: "#FF7C1B" }
                    : {}
                }
              >
                With Walkway
              </span>
              <span
                onClick={() =>
                  handleWalkWayType("Without", dispatch, roofIndex, roofDetail)
                }
                style={
                  roofDetail.walkWayType === "Without"
                    ? { backgroundColor: "#FF7C1B" }
                    : {}
                }
              >
                Without Walkway
              </span>
            </div>
          </div>
          <div className="formShedInfo">
            <label>Walkway Space(ft)</label>
            <input
              type="text"
              placeholder="walkWaySpace"
              name="roadSpace"
              value={roofDetail.roadSpace}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
              disabled={roofDetail.walkWayType === "With" ? false : true}
              style={
                roofDetail.walkWayType === "With"
                  ? {}
                  : { backgroundColor: "#E9ECEF" }
              }
            ></input>
          </div>
          <div className="formShedInfo">
            <label>Walkway Column</label>
            <input
              type="text"
              placeholder="walkWayCol"
              name="walkWayCol"
              value={roofDetail.walkWayCol}
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
              disabled={roofDetail.walkWayType === "With" ? false : true}
              style={
                roofDetail.walkWayType === "With"
                  ? {}
                  : { backgroundColor: "#E9ECEF" }
              }
            ></input>
          </div>
        </div>
      )}
    </>
  );
}
